import { profiles } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

// Профили членов семьи текущего аккаунта (постановка «Родители и дети»).
// В контексте активного детского профиля бэкенд вернёт 403 — хук отдаёт пустой список.
export const useProfiles = (options) => {
	const response = useQuery({
		queryKey: ['family-profiles'],
		queryFn: () => profiles.getAll(),
		select: (data) => data.data,
		retry: false,
		...options
	})

	return response
}
